import { createContext } from 'react';

/**
 * Expression paths from the document type's sample data, offered by the chip popover's
 * autocomplete. Provided by DocumentTemplateVisualEditor; consumed by ScribanExprChipView
 * (React NodeViews render inside the editor's React tree, so context flows normally).
 */
export const ScribanPaletteContext = createContext<string[]>([]);
